var _defs, _path, _path2, _path3, _path4, _path5, _circle, _circle2, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReferral(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "referral_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".referral_svg__cls-3,.referral_svg__cls-5{stroke:#0e5b7c;stroke-linecap:round}.referral_svg__cls-5{stroke-miterlimit:10}.referral_svg__cls-3{stroke-linejoin:round;fill:#6e9db0}.referral_svg__cls-5{fill:none}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    stroke: "#0e5b7c",
    strokeLinecap: "round",
    fill: "#f8f8f8",
    d: "M15.35 59.1h105.7v72.09H15.35z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    fill: "#0e5b7c",
    stroke: "#0e5b7c",
    strokeLinecap: "round",
    d: "M28.85 71.61h78.69v50.16H28.85z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "referral_svg__cls-3",
    d: "M15.35 95.27V59.35l26.42 17.96 26.42 17.96-26.42 17.96-26.42 17.96V95.27zM121.04 95.27v35.92l-26.42-17.96-26.43-17.96 26.43-17.96 26.42-17.96v35.92z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "referral_svg__cls-3",
    d: "M68.19 131.19H15.35l26.42-25.9 14.45-14.16a17.15 17.15 0 0124 0l14.45 14.16 26.33 25.9zM113.14 47.59l-28.34-22c-5-3.81-7.17-6.38-16.61-6.81-9.43.43-11.6 3-16.6 6.81l-28.35 22c-4.7 3.53-7.89 6.71-7.89 11.76H121c0-5.05-3.15-8.23-7.86-11.76z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbc282",
    strokeLinejoin: "round",
    stroke: "#0e5b7c",
    strokeLinecap: "round",
    d: "M110.46 40.15l6.48-3.32 3.95 6.12 7.28.36.37 7.28 6.12 3.95-3.33 6.49 3.33 6.48-6.12 3.96-.37 7.27-7.28.37-3.95 6.12-6.48-3.33-6.49 3.33-3.95-6.12-7.28-.37-.36-7.27-6.12-3.96 3.32-6.48-3.32-6.49 6.12-3.95.36-7.28 7.28-.36 3.95-6.12 6.49 3.32z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "referral_svg__cls-5",
    cx: 103.6,
    cy: 54.17,
    r: 3.73
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "referral_svg__cls-5",
    cx: 117.31,
    cy: 67.88,
    r: 3.73
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "referral_svg__cls-5",
    d: "M101.37 70.11l18.17-18.16"
  })));
}
export default SvgReferral;